import React, { SVGProps } from "react";
export default function SupUserAnon001(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.3809L10 0.76178L2 5.3809M18 5.3809V14.6191L10 19.2383M18 5.3809L10 10M10 19.2383L2 14.6191V5.3809M10 19.2383V10M2 5.3809L10 10M10 2.55427L5.20885 5.3809L6.79441 6.34609L8.37997 5.3809L10 6.34609M10 2.55427L14.5843 5.3809L13.2056 6.34609L11.62 5.3809L10 6.34609M10 2.55427V6.34609M16.2733 13.6222V8.34541L14.5843 9.20719V10.9997L13.2056 11.8509M16.2733 13.6222L11.62 16.3772V14.6191L13.2056 13.6222V11.8509M16.2733 13.6222L13.2056 11.8509M3.58882 13.7018V8.34541L5.20885 9.20719V10.9997L6.79441 11.8509M3.58882 13.7018L8.37997 16.3772V14.6191L6.79441 13.6222V11.8509M3.58882 13.7018L6.79441 11.8509"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
